import React from 'react'

function FieldSeasonFormAdvanced() {
  return <h1>FieldSeasonFormAdvanced</h1>
}

export default FieldSeasonFormAdvanced
